
import { monochrome, footerHeight } from 'themes/variables';
import { wrapper } from 'themes/mixins';

export default theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    ...wrapper(),
  },
  content: {
    minHeight: `calc(100vh - ${footerHeight}px)`,
    paddingTop: 70,
    backgroundColor: monochrome.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 2,
  },
});
